import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

export function LoadingSkeleton({ lines = 3 }: { lines?: number }) {
  return (
    <Card>
      <div className="space-y-3">
        {Array.from({ length: lines }).map((_, i) => (
          <div
            key={i}
            className={cn(
              'h-4 rounded-(--radius-sm) bg-surface-hover animate-pulse',
              i === lines - 1 ? 'w-2/3' : 'w-full'
            )}
          />
        ))}
      </div>
    </Card>
  );
}
